import { Next, Pipe } from './types';

export class Pipeline<TValue, TResult> {
    public constructor(
        public readonly pipes: ReadonlyArray<Pipe<TValue, TResult>>,
        public readonly terminal: Next<TValue, TResult>,
    ) {}

    public run(initialValue: TValue): TResult {
        const composed: Next<TValue, TResult> = this.pipes.reduceRight(
            (nextFn, pipe) => (value) => pipe.handle(value, nextFn),
            this.terminal,
        );

        return composed(initialValue);
    }
}
